import { SupportedLocaleEnum } from 'localization';
import { Currency, getCurrencyPrecision } from 'domains-billing-currency';
import { currencyToPaymentCurrency } from 'domains-billing-web-mappers';

import { getPricing } from '../../productCatalog/helpers';
import { ProductItem } from '../types';
import { productToPriceComponents } from './productToPriceComponents';
import BigNumber from 'bignumber.js';

export function getProductItemsTotal(
  productItems: ProductItem[],
  locale: SupportedLocaleEnum,
  currency: Currency
): number {
  const result = productItems.reduce((total: number, item: ProductItem) => {
    const priceComponents = productToPriceComponents(item.product);
    const { netPrice } = getPricing({
      priceComponents,
      locale,
      currency: currencyToPaymentCurrency(currency),
    });

    const precision = getCurrencyPrecision(currency);
    
    const itemTotal = Number(
      new BigNumber(netPrice).multipliedBy(item.quantity).toFixed(precision)
    );

    return total + itemTotal;
  }, 0);

  return Math.round(result * 100) / 100;
}
